module.exports = {"id":"219787","name":"Andrés Mosquera","rating":"73","photo":"./data/images/photos/2/219787.png","club":{"name":"León","logo":"./data/images/clubs/Leon.png"},"positions":["DC","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresMosquera0.json
// module id = 393
// module chunks = 0